import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const ThemeRow = withStyles(CoreView, {style: {flexDirection: 'row'}, type: 'ThemeRow'});